//! Called by : src/App.vue (button-logout) !!! unused !!!

<template>
    <button class="btn btn-primary py-2 px-4" @click="logout">
        <span class="oi oi-power-standby mr-2" style="font-size: 1rem;"></span>
        {{ $t('common.logout') }}
    </button>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$router.push({name: 'connect'})
    },
  }
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/header/ButtonLogout.vue